// import Store from '@/store'
import i18n from '@/i18n'

const headerData = (vm, title) => {
    const headerVal = []
    headerVal[0] = vm.reportHeadData.orgName
    headerVal[1] = vm.reportHeadData.address
    headerVal[2] = vm.reportHeadData.heading
    headerVal[3] = title
    headerVal[4] = ''
    headerVal[5] = getHeadParam(vm)
    headerVal[6] = ''
    return headerVal
}

const excelBody = (vm) => {
    const listData = vm.report_data
    const listContractor = []
    listData.map((item, index) => {
        if (i18n.locale === 'en') {
            listContractor.push({
              'SL No': (index + 1),
              'Name ,Organization, Designation ': item.name_en + ',\n ' + item.org_en + ', \n' + item.designation_en,
              'Phone No ': '0' + item.mobile_no
            })
        } else {
            listContractor.push({
                'ক্রমিক সংখ্যা': vm.$n(index + 1),
                'নাম, সংগঠন, পদবী ': item.name_bn + ', \n' + item.org_bn + ', \n' + item.designation_bn,
                'ফোন নম্বর  ': i18n.locale === 'bn' ? 'o' : '0' + vm.$n(item.mobile_no, { useGrouping: false })
            })
        }
    })
  if (i18n.locale === 'en') {
    listContractor.push({
      'SL No': null,
      'Name ,Organization, Designation ': 'Total',
      'Phone No ': listData.length
    })
  } else {
    listContractor.push({
      'ক্রমিক সংখ্যা': null,
      'নাম, সংগঠন, পদবী ': 'মোট',
      'ফোন নম্বর  ': vm.$n(listData.length, { useGrouping: false })
    })
  }
    return listContractor
}

const getHeadParam = (vm) => {
    let head = ''
    head = vm.$t('report_management.circular') + ' : ' + (vm.search.circular_id ? vm.getMemoName(vm.search.circular_id) : vm.$t('globalTrans.all'))
    head = head + ', ' + vm.$t('elearning_config.training') + ' : ' + (vm.search.circular_id ? vm.trainingNameByMemo(vm.search.circular_id) : vm.$t('globalTrans.all'))
    head = head + ', ' + vm.$t('globalTrans.fiscal_year') + ' : ' + (vm.search.fiscal_year_id ? vm.fiscalYear(vm.search.fiscal_year_id) : vm.$t('globalTrans.all'))
    return head
}

export default {
    headerData,
    excelBody
}
